import { SettingsMediaImage, Settings, WidgetData } from "./data"
import { WpMediaImage, loadImage } from "./wp-media-image"
import { Widget } from "./widget"

export type ImageBoxData = WidgetData & {
  settings: Settings & {
    image?: SettingsMediaImage,
    title_text: string,
    description_text: string,
  },
  widgetType: "image-box"
}

export class ImageBoxWidget extends Widget {
  image: WpMediaImage | undefined
  description: string
  title: string

  constructor(data: ImageBoxData) {
    super(data);
    this.description = data.settings.description_text;
    this.title = data.settings.title_text;
    this.image = data.settings.image &&
      loadImage(data.settings.image);
  }
}
